import { render, staticRenderFns } from "./OrderBuyPInside.vue?vue&type=template&id=726e58b8&"
import script from "./OrderBuyPInside.vue?vue&type=script&lang=js&"
export * from "./OrderBuyPInside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports